import { render, staticRenderFns } from "./AssociationOwners.vue?vue&type=template&id=41e381fa&scoped=true"
import script from "./AssociationOwners.vue?vue&type=script&lang=js"
export * from "./AssociationOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e381fa",
  null
  
)

export default component.exports